import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { DatePipe, formatDate, formatNumber } from '@angular/common';
import { from, finalize, filter, Subscription, Subject } from 'rxjs';
import { concatMap, switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Title } from "@angular/platform-browser";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { FilterService, MessageService } from 'primeng/api';
import { GlobalConnSettings, GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { GraphData, DailyGraphData } from 'src/app/shared/dashboard';
import { Client, CustomerCategory } from 'src/app/shared/client';
import { Person } from 'src/app/shared/person';
import { ClientApiService } from 'src/app/services/client-api.service';
import { DocListEntry, DocTypes } from 'src/app/shared/doc-list-entry';
import { Currency } from 'src/app/shared/currency';
import { RestApiService } from 'src/app/services/rest-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';

interface Customer {

  CLIID: number;
  CLIENTSNIKNAME?: string;
  CLIENTSNAME: string;

  overallSalesVolume: number;

};

interface CombinedSalesData {

  CLIID: number;
  CLIENTSNIKNAME?: string;
  CLIENTSNAME: string;
  DATEFROM: Date;
  DATETO: Date;
  SALESAMOUNT: number;
  PAYMENTS: number;
};

interface PivotTableRow {

  rowLabel: string;
  rowData: number[];
  rowSummary: number;

};

interface PivotTable {
    
  rowHeader: string[];
  rows: PivotTableRow[];
  rowSummary: number[];
  rowValueTop: number[];
  rowValueBot: number[];

};

interface Period {
  name: string,
  code: number
}

@Component({
  selector: 'app-home-chart-annual-sales',
  templateUrl: './home-chart-annual-sales.component.html',
  styleUrls: ['./home-chart-annual-sales.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeChartAnnualSalesComponent implements OnInit, OnDestroy, OnChanges {

  @Input() today: Date;

  globalSettinsData: GlobalSettingsData;

  dateFrom: Date;
  dateTo: Date;
  customers: Customer[] = [];
  divider: number = 10;       // Top 10 customers
  currency: number;

  datasource: DocListEntry[] = [];// All documents for stated period (and global filter)

  salesData: CombinedSalesData[] = [];

  selectedCustomers: Customer[] = [];

  periods: Period[] = [

    //{ name: 'Неделя', code: 0},
    { name: 'Месяц', code: 1},
    { name: 'Квартал', code: 3},
    { name: 'Полугодие', code: 6},
    { name: 'Год', code: 12},
  ];

  selectedPeriod: number = 1;

  pivotTable: PivotTable = {
    rowHeader: [],
    rows: [],
    rowSummary: [],
    rowValueTop: [],
    rowValueBot: [],
  };

  filteredPivotTable: PivotTable = {
    rowHeader: [],
    rows: [],
    rowSummary: [],
    rowValueTop: [],
    rowValueBot: [],
  };

  annualSalesSubj$ = new Subject<{
    'DATEFROM': Date,
    'DATETO': Date,
    'CUSTOMERLIST': Customer[],
    'PERIOD': number,
    'DIVIDER': number,
    'CURRID': number
  }>();

  annualSalesQuery: Subscription;

  annualSalesData: GraphData;

  plugins = [ChartDataLabels];

  annualSalesOptions = {
    scales: {

      'left': {
        type: 'linear',
        id: 'left',
        position: 'left',
        scaleBeginAtZero: true,
        grid: {
          color: 'green',
          borderColor: 'darkgreen',
          tickColor: 'blue'
        },
        ticks: {
          beginAtZero: true,
          min: 0
        }
      },

    //  'right': {
    //    type: 'linear',
    //    id: 'right',
    //    position: 'right',
    //    scaleBeginAtZero: true,
    //  //  grid: {
    //  //    color: 'red',
    //  //    borderColor: 'darkred',
    //  //    tickColor: 'grey'
    //  //  },
    //  },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || '';

            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat(['uk-UA', 'ru-RU', 'en-US'], { maximumFractionDigits: 1}).format(context.parsed.y);
            }
            return [label/*, JSON.stringify(context.parsed), JSON.stringify(context.dataset), context.formattedValue, JSON.stringify(context.raw)*/];
          }
        }
      },
      datalabels: {
        color: 'blue',
        labels: {
          title: {
            font: {
              weight: 'bold'
            }
          },
          value: {
            color: 'green'
          }
        }
      }
    }
  };

  cf3: any = {};    // to store f[string] filters value

  // Return customer index to disply in the customers' list
  public getCustomerIndex(c: Customer): number {

    return ((((this.selectedCustomers || []).length > 0) ? this.selectedCustomers : this.customers).findIndex(e => (e.CLIID == c.CLIID)) + 1);

  }

  constructor(
    private docApi: DocumentApiService,
    private titleService: Title,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** HomeChartAnnualSalesComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {
        case 'clean':

        case 'today':
          if (this.globalSettinsData) {
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** HomeChartAnnualSalesComponent in ngOnDestroy");

    if (this.annualSalesQuery) { this.annualSalesQuery.unsubscribe(); }
  }

  calculateGraphData() {
    this.filteredPivotTable.rowHeader = [... this.pivotTable.rowHeader];

    // here we ended the preliminary arrays buildup
    // after that we would copy fata with selected customer
    // initial filtered array is equal to source array

    this.filteredPivotTable.rows = [... this.pivotTable.rows.filter(e => {

      if ((this.selectedCustomers || []).length == 0) return true;

      return (this.selectedCustomers.findIndex(s => (s.CLIENTSNIKNAME == e.rowLabel)) != -1);
    })];

    // build top and bottom sum (above and below the divider)

    for (let x = 0; x < this.filteredPivotTable.rowHeader.length; ++x) {

      this.filteredPivotTable.rowSummary[x] = this.filteredPivotTable.rows.reduce((r, s) => r + s.rowData[x], 0);

      this.filteredPivotTable.rowValueTop[x] = this.filteredPivotTable.rows.slice(0, this.divider).reduce((r, s) => r + s.rowData[x], 0);

      this.filteredPivotTable.rowValueBot[x] = this.filteredPivotTable.rows.slice(this.divider).reduce((r, s) => r + s.rowData[x], 0);
    }

//    this.annualSalesData.datasets[0].data = [...this.filteredPivotTable.rowSummary];
//    this.annualSalesData.datasets[1].data = [...this.filteredPivotTable.rowValueTop];
//    this.annualSalesData.datasets[2].data = [...this.filteredPivotTable.rowValueBot];
    this.annualSalesData = {
      labels: [...this.filteredPivotTable.rowHeader],
      datasets: [
        {
          label: 'Общий объем',
//          yAxisID: 'right',
          yAxisID: 'left',
          data: this.filteredPivotTable.rowSummary,
          type: 'line',
          fill: false,
          borderColor: '#111111',
          backgroundColor: '#277622',
          tension: .4,
          datalabels: {
            color: '#FFCE56'
          }
        },
        {
          label: 'Корпоратив',
          yAxisID: 'left',
          data: this.filteredPivotTable.rowValueTop,
          fill: false,
          backgroundColor: '#277622',
        },
        {
          label: 'Розница',
          yAxisID: 'left',
          data: this.filteredPivotTable.rowValueBot,
          fill: false,
          backgroundColor: '#101DBB'
        },
      ],
      options: {
      }
    };
  }

  subscribeAnnualSalesData() {

    this.annualSalesQuery =
      this.annualSalesSubj$
      .pipe(
        debounceTime(300),
        switchMap(opt => {

          this.salesData = [];
          this.datasource = [];

          return this.docApi.getDocListBetweenDatesWithCurrency(3, opt.DATEFROM, opt.DATETO, opt.CURRID).pipe(
            concatMap(data => {
              this.datasource = data;
              this.salesData = [];

              console.log("*** HomeChartAnnualSalesComponent in subscribeAnnualSalesData => 1");

              return from(this.datasource/*.filter(e => (((this.selectedCustomers || []).length ? (this.selectedCustomers.findIndex(c => c.CLIID == e.DOCCLIENTSID) > -1) : true)))*/);
            }),

            concatMap(r => {
              // console.log("*** HomeChartAnnualSalesComponent in subscribeAnnualSalesData => 2");

              let d: Date = new Date(r.DOCDATE);
              let f: Date;
              let t: Date;

              switch (opt.PERIOD) {
                case 1:
                  f = new Date(d.getUTCFullYear(), d.getUTCMonth(), 1);
                  t = new Date(d.getUTCFullYear(), d.getUTCMonth() + 1, 1);
                  break;

                case 3:
                case 6:

                  let m = ((Math.floor(d.getUTCMonth() / opt.PERIOD))) * opt.PERIOD;

                  f = new Date(d.getUTCFullYear(), m, 1);
                  t = new Date(d.getUTCFullYear(), m + opt.PERIOD);
                  break;

                case 12:
                  f = new Date(d.getUTCFullYear(), 0, 1);
                  t = new Date(d.getUTCFullYear() + 1, 0, 1);
                  break;
              }

              let i = this.salesData.findIndex(e => ((e.CLIID == r.DOCCLIENTSID) && (d >= e.DATEFROM) && (d < e.DATETO)));

              if (i == -1) {

                this.salesData.push({
                  CLIID: r.DOCCLIENTSID,
                  CLIENTSNAME: r.CLIENTSNAME,
                  CLIENTSNIKNAME: r.PARTNERNAME,
                  SALESAMOUNT: r.DOCVSUM / 1000,
                  DATEFROM: f,
                  DATETO: t,
                  PAYMENTS: 1
                });
              } else {
                this.salesData[i].PAYMENTS++;
                this.salesData[i].SALESAMOUNT += r.DOCVSUM / 1000;
              }

              return from(this.salesData);
            }),

            finalize(() => {

              console.log("*** HomeChartAnnualSalesComponent in subscribeAnnualSalesData => finalize");

              //environment.production || console.table(this.salesData);
              //environment.production || console.table(this.datasource);

              this.pivotTable.rows = [];

              this.pivotTable.rowHeader =
                Array
                  .from(new Set((this.salesData || []).map(v => (formatDate(v.DATEFROM, 'yyyy.MM', 'uk')))))
                  .sort((a, b) => {
                    if (a > b) { return 1; }
                    if (a < b) { return -1; }
                    return 0;
                  });

              this.pivotTable.rowSummary = new Array(this.pivotTable.rowHeader.length);
              this.pivotTable.rowValueTop = new Array(this.pivotTable.rowHeader.length);
              this.pivotTable.rowValueBot = new Array(this.pivotTable.rowHeader.length);

              this.pivotTable.rowSummary.fill(0);
              this.pivotTable.rowValueTop.fill(0);
              this.pivotTable.rowValueBot.fill(0);

              this.salesData.forEach(d => {

                let n = this.pivotTable.rowHeader.findIndex(s => s == formatDate(d.DATEFROM, 'yyyy.MM', 'uk'));

                let k = this.pivotTable.rows.findIndex(r => r.rowLabel == d.CLIENTSNIKNAME);

                if (k > -1) {
                  this.pivotTable.rows[k].rowData[n] += d.SALESAMOUNT;
                } else {

                  let p: PivotTableRow = { rowData: new Array(this.pivotTable.rowHeader.length), rowLabel: d.CLIENTSNIKNAME, rowSummary: 0 };
                  p.rowData.fill(0);

                  p.rowData[n] = d.SALESAMOUNT;
                  this.pivotTable.rows.push(p);
                }
              });

              // calculate total in row
              this.pivotTable.rows.forEach(r => r.rowSummary = r.rowData.reduce((r, s) => r += s, 0));

              this.divider = Math.round(this.pivotTable.rows.length / 5);

              // calculate total in column
              for (let x = 0; x < this.pivotTable.rowHeader.length; ++x) {

                this.pivotTable.rowSummary[x] = this.pivotTable.rows.reduce((r, s) => r + s.rowData[x], 0);
              }

              // environment.production || console.table(this.pivotTable);

              // Finally sort rows by descending
              this.pivotTable.rows = [...

                this.pivotTable.rows.sort((a, b) => {
                  if (a.rowSummary > b.rowSummary) { return -1; }
                  if (a.rowSummary < b.rowSummary) { return 1; }
                  return 0;
                })
              ];

              // build customers pool for further selection
              this.customers =

                this.pivotTable.rows.map(r => ({
                  CLIID: this.datasource.find(v => r.rowLabel == v.PARTNERNAME).DOCCLIENTSID,
                  CLIENTSNIKNAME: r.rowLabel,
                  CLIENTSNAME: this.datasource.find(v => r.rowLabel == v.PARTNERNAME).CLIENTSNAME,
                  overallSalesVolume: r.rowSummary
                }));

              // environment.production || console.table(this.customers);

              this.calculateGraphData();
            })
          )
        }),
      )
      .subscribe();
  }

  ngOnInit(): void {
    console.log("*** HomeChartAnnualSalesComponent in ngOnInit");
    
    this.titleService.setTitle('Годовые продажи - домашняя страница');

    this.today = new Date();

    this.dateTo   = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1, 0);
    this.dateFrom = new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() - 12, 1, 0);

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.currency = this.globalSettinsData.viewDCurrencyId || this.globalSettinsData.balanceCurrencyId;

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.subscribeAnnualSalesData();

  //  this.annualSalesSubj$.next({
  //    DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
  //    DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
  //    CURRID: this.currency,
  //    CUSTOMERLIST: this.selectedCustomers || this.customers,
  //    DIVIDER: this.divider
  //  });
  }

  onDateFromSelect(event) {
    console.log("*** HomeChartAnnualSalesComponent in onDateFromSelect");

    this.annualSalesSubj$.next({
      DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
      DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
      CURRID: this.currency,
      PERIOD: this.selectedPeriod,
      CUSTOMERLIST: this.selectedCustomers || this.customers,
      DIVIDER: this.divider
    })
  }

  onDateToSelect(event) {
    console.log("*** HomeChartAnnualSalesComponent in onDateToSelect");

    this.annualSalesSubj$.next({
      DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
      DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
      CURRID: this.currency,
      PERIOD: this.selectedPeriod,
      CUSTOMERLIST: this.selectedCustomers || this.customers,
      DIVIDER: this.divider
    });
  }

  onDateFromInput(event) {
    console.log("*** HomeChartAnnualSalesComponent in onDateFromInput");

    if (this.dateFrom) {
      this.annualSalesSubj$.next({
        DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
        DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
        CURRID: this.currency,
        PERIOD: this.selectedPeriod,
        CUSTOMERLIST: this.selectedCustomers || this.customers,
        DIVIDER: this.divider
      })
    }
  }

  onDateToInput(event) {
    console.log("*** HomeChartAnnualSalesComponent in onDateToInput");

    if (this.dateTo) {
      this.annualSalesSubj$.next({
        DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
        DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
        CURRID: this.currency,
        PERIOD: this.selectedPeriod,
        CUSTOMERLIST: this.selectedCustomers || this.customers,
        DIVIDER: this.divider
      });
    }
  }

  onCustomerChange(event) {
    console.log("*** HomeChartAnnualSalesComponent in onCustomerChange");

    this.calculateGraphData();

  //  this.annualSalesSubj$.next({
  //    DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
  //    DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
  //    CURRID: this.currency,
  //    CUSTOMERLIST: this.selectedCustomers || this.customers,
  //    DIVIDER: this.divider
  //  });
  }

  onPeriodChange(event) {
    console.log("*** HomeChartAnnualSalesComponent in onCurrencySelection");

    this.annualSalesSubj$.next({
      DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
      DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
      CURRID: this.currency,
      PERIOD: this.selectedPeriod,
      CUSTOMERLIST: this.selectedCustomers || this.customers,
      DIVIDER: this.divider
    });
  }

  onCurrencySelection(event: Currency) {
    console.log("*** HomeChartAnnualSalesComponent in onCurrencySelection: " + JSON.stringify(event));

    this.currency = event.CURID;

    this.annualSalesSubj$.next({
      DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
      DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
      CURRID: this.currency,
      PERIOD: this.selectedPeriod,
      CUSTOMERLIST: this.selectedCustomers || this.customers,
      DIVIDER: this.divider
    });
  }

  onDividerChange(event) {
    console.log("*** HomeChartAnnualSalesComponent in onDividerChange");

    this.calculateGraphData();

  //  this.annualSalesSubj$.next({
  //    DATEFROM: new Date(this.dateFrom.getFullYear(), this.dateFrom.getMonth(), 1, 0),
  //    DATETO: new Date(this.dateTo.getFullYear(), this.dateTo.getMonth() + 1, 1, 0),
  //    CURRID: this.currency,
  //    CUSTOMERLIST: this.selectedCustomers || this.customers,
  //    DIVIDER: this.divider
  //  });
  }

  //renderCell(x: CombinedSalesData[]): string {
  //  return formatNumber(x.reduce((r, c) => r + (c.SALESAMOUNT ?? 0), 0), 'uk', '1.0-0');
  //}

  selectData(event) {
    // this.messageService.add({ severity: 'info', summary: 'Data Selected', 'detail': this.annualSalesData.datasets[event.element._datasetIndex].data[event.element._index].toString() });
  }

  reloadSalesDataTable(event) {
    console.log('*** HomeChartAnnualSalesComponent reloadSalesDataTable: ')

    this.salesData = [... this.salesData];
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });

      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  /*
  CLIID: number;
  CLIENTSNIKNAME?: string;
  CLIENTSNAME: string;
  DATEFROM: Date;
  DATETO: Date;
  SALESAMOUNT: number;
  PAYMENTS: number;
  */

  onExportSalesData() {
    console.log('*** HomeChartAnnualSalesComponent onExportSalesData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.salesData);

      let exportData: any =
        this.salesData.map(e => ({
          'Покупатель': e.CLIENTSNIKNAME,
          'Полное название': e.CLIENTSNAME,
          'Начало': e.DATEFROM,
          'Конец': e.DATETO,
          'Продажи': e.SALESAMOUNT,
          'Платежи': e.PAYMENTS,
        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { document: worksheet }, SheetNames: ['document'] };

      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      this.saveAsExcelFile(excelBuffer, "document");
    });
  }

}
